import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { MentoringPairApiModel } from '@app/api/api-models/program/mentoring/MentoringPairApiModel';

@Injectable()
export class MtPairsService extends CrudService<MentoringPairApiModel, string> {
  public apiUrl = 'mentoring-pairs';

  public getPairsList(programRoleId: string): Observable<MentoringPairApiModel[]> {
    return this.http.get<MentoringPairApiModel[]>(`${this.apiUrl}/get-list/${programRoleId}`);
  }
}
